import React from 'react'
import { Row, Col, Table, Tab } from 'react-bootstrap'

type Task = {
  due: string
  attempts: number
  assigned: string
}

type Section = {
  title: {
    label: string
    color: string
  }
  tasks: Task[]
}

type TaskTableProps = {
  tasks: Task[]
  title: {
    label: string
    color: string
  }
}

const TaskTable: React.FC<TaskTableProps> = ({ tasks, title }) => {
  return (
    <>
      <h5 className="p-2">
        <span className={`badge ${title.color} text-white`}>{title.label}</span>
      </h5>
      <Table className="table1">
        <thead>
          <tr>
            <th scope="col">Due</th>
            <th scope="col">Attempts</th>
            <th scope="col">Assigned</th>
            <th scope="col">Action</th>
          </tr>
        </thead>
        <tbody>
          {tasks.map((task, index) => (
            <tr key={index}>
              <td>{task.due}</td>
              <td>{task.attempts}</td>
              <td>{task.assigned}</td>
              <td className="pcmt-actions">
                <button
                  type="button"
                  className="btn btn-icon1 p-0"
                  aria-label="Complete"
                >
                  <i className="bi bi-check-lg" aria-hidden="true" />
                </button>
                <button
                  type="button"
                  className="btn btn-icon1 p-0"
                  aria-label="Repeat"
                >
                  <i className="bi bi-repeat" aria-hidden="true" />
                </button>
                <button
                  type="button"
                  className="btn btn-icon1 p-0"
                  aria-label="Delete"
                >
                  <i className="bi bi-trash" aria-hidden="true" />
                </button>
              </td>
            </tr>
          ))}
        </tbody>
        <tfoot>
          <tr>
            <td colSpan={4}>
              <button className="btn btn-sm bg-light border pt-1 pb-1">
                <i className="bi bi-clipboard me-1"></i>View details
              </button>
            </td>
          </tr>
        </tfoot>
      </Table>
    </>
  )
}

const PatientTasks: React.FC = () => {
  const sections: Section[] = [
    {
      title: { label: 'Past due account', color: 'bg-danger' },
      tasks: [{ due: '25 August 2023', attempts: 0, assigned: 'Sina' }],
    },
    {
      title: { label: 'Unscheduled treatment', color: 'bg-green' },
      tasks: [{ due: '25 August 2023', attempts: 0, assigned: 'Sina' }],
    },
  ]

  return (
    <Tab.Pane eventKey="second">
      <Row>
        <Col>
          <h4 className="p-2 mb-0">Follow-ups</h4>
          {sections.map((section, index) => (
            <TaskTable
              key={index}
              tasks={section.tasks}
              title={section.title}
            />
          ))}
        </Col>
      </Row>
    </Tab.Pane>
  )
}

export default PatientTasks
